import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { BookPreview } from './BookPreview';
export function Hero() {
  const [showPreview, setShowPreview] = useState(false);
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-cream py-20 px-6" data-id="element-216">
      {/* Decorative Blobs */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-amber/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-217"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-terracotta/10 rounded-full mix-blend-multiply filter blur-3xl opacity-70" data-id="element-218"></div>

      <div className="max-w-6xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-219">
        <AnimatedSection delay={0.2} className="flex flex-col items-start text-left" data-id="element-220">
          <motion.span initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.5,
          duration: 1
        }} className="text-terracotta font-semibold tracking-wider uppercase text-sm mb-4" data-id="element-221">
            Nuevo Lanzamiento
          </motion.span>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-balance" data-id="element-222">
            Rompiendo el{' '}
            <span className="text-terracotta italic" data-id="element-223">Silencio</span>
          </h1>
          <p className="text-lg md:text-xl text-medium-brown mb-10 leading-relaxed max-w-lg" data-id="element-224">
            Un camino de sanación, valentía y empoderamiento para sobrevivientes
            de abuso infantil. Descubre cómo transformar el dolor en fuerza.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-225">
            <motion.a href="https://7kaxyn4bz2pgw2pi-97302217014.shopifypreview.com/products_preview?preview_key=7423b83fb7c6725a7ae81fffa389df5e" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-terracotta text-white px-8 py-4 rounded-full font-semibold shadow-warm hover:bg-terracotta-dark transition-colors duration-300 text-center" data-id="element-226">
              Leer mi historia
            </motion.a>
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={() => setShowPreview(true)} className="border-2 border-amber text-deep-brown px-8 py-4 rounded-full font-semibold hover:bg-amber/10 transition-colors duration-300" data-id="element-227">
              Conocer Más
            </motion.button>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.4} className="relative flex justify-center lg:justify-end" data-id="element-228">
          <div className="relative w-full max-w-md rounded-2xl shadow-warm-lg overflow-hidden bg-deep-brown" data-id="element-229">
            <img src="https://cdn.magicpatterns.com/uploads/fTt7DvZ6cZM2cKcYa4N9ri/ROMPIENDO_EL_SILENCIO.jpg" alt="Portada del libro Rompiendo el Silencio por Daniela Garcia Lantigua" className="w-full h-auto block" data-id="element-230" />
            {/* Decorative spine shadow */}
            <div className="absolute left-0 top-0 bottom-0 w-6 bg-gradient-to-r from-black/15 to-transparent" data-id="element-231"></div>
            {/* Subtle page edge effect */}
            <div className="absolute right-0 top-2 bottom-2 w-1 bg-gradient-to-l from-black/5 to-transparent" data-id="element-232"></div>
          </div>
        </AnimatedSection>
      </div>

      <BookPreview isOpen={showPreview} onClose={() => setShowPreview(false)} data-id="element-233" />
    </section>;
}